import React from 'react';

import Cancellation from 'component/Search/Filter/Cancellation';
import GuestRating from 'component/Search/Filter/GuestRating';
import HotelCategory from 'component/Search/Filter/HotelCategory';
import MealType from 'component/Search/Filter/MealType';
import PopularFilter from 'component/Search/Filter/PopularFilter';
import PriceSlider from 'component/Search/Filter/PriceSlider';
import Rebook from 'component/Search/Filter/Rebook';
import RoomType from 'component/Search/Filter/RoomType';
import ScopedAttribute from 'component/Search/Filter/ScopedAttribute';
import Special from 'component/Search/Filter/Special';
import ViewType from 'component/Search/Filter/ViewType';

import { Feature } from 'config/features';
import {
    beachListArray,
    viewTypeListArray,
} from 'config/Filter/sectionCollection';

import { useFeatureList } from 'hooks/useFeature';

const ScrollView = () => {
    const [
        isRepositioningFlexFilterAfterPopularActive,
        isRepositioningFlexFilterAfterPriceSliderActive,
    ] = useFeatureList(
        Feature.RepositioningFlexFilterAfterPopular,
        Feature.RepositioningFlexFilterAfterPriceSlider
    );
    const isFlexFilterOnTopActive =
        !isRepositioningFlexFilterAfterPopularActive &&
        !isRepositioningFlexFilterAfterPriceSliderActive;

    return (
        <>
            {isFlexFilterOnTopActive && (
                <>
                    <Cancellation />
                    <Rebook />
                    <Special />
                    <PriceSlider />
                    <PopularFilter />
                </>
            )}
            {isRepositioningFlexFilterAfterPriceSliderActive && (
                <>
                    <PopularFilter />
                    <PriceSlider />
                    <Cancellation />
                    <Rebook />
                    <Special />
                </>
            )}
            {isRepositioningFlexFilterAfterPopularActive && (
                <>
                    <PriceSlider />
                    <PopularFilter />
                    <Cancellation />
                    <Rebook />
                    <Special />
                </>
            )}
            <HotelCategory />
            <GuestRating />
            <MealType />
            <RoomType isSticky />
            <ViewType viewTypeListArray={viewTypeListArray} />
            <ScopedAttribute
                attributeListArray={beachListArray}
                headlineKey="TRANS-beach-features"
            />
        </>
    );
};

export default ScrollView;
